import { Component, Prop, h } from '@stencil/core';
import account from '../../../assets/header/account_grey.svg';
import Cookies from 'js-cookie';
import convertToLinks from '../../../utils/convert_to_links';

@Component({
  tag: 'default-header',
  styleUrl: 'default-header.scss',
  assetsDirs: ['.../assets'],
})
export class DefaultHeader {
  @Prop() serviceNumber: string;
  @Prop() desktopBannerMessage: string;
  @Prop() mobileBannerMessage: string;

  render() {
    const onMenuBtnClick = () => {
      const isActiveClassAdded = document.getElementById('menuButton').classList.toggle('active');
      const ciMobileSubnav = document.getElementsByClassName('ciMobileSubnav')[0] as HTMLElement;
      const ciBodyTag = document.getElementsByTagName('body')[0] as HTMLElement;
      const overlay = document.getElementById('overlay');
      const menu = document.getElementById('menu');
      if (isActiveClassAdded) {
        ciMobileSubnav.style.visibility = 'visible';
        overlay.className = 'ci-drawer-overlay openOverlay';
        menu.className = 'ci-drawer-menu openMenu';
        ciBodyTag.style.overflow = 'hidden';
      } else {
        menu.className = 'ci-drawer-menu closeMenu';
        overlay.className = 'ci-drawer-overlay closeOverlay';
        setTimeout(function () {
          ciMobileSubnav.style.visibility = 'hidden';
          ciBodyTag.style.overflow = 'visible';
        }, 200);
      }
      convertToLinks()
    };

    const handleShowOverlay = () => {
      const overlay = document.getElementsByClassName('ciHeader-overlay')[0];
      overlay.classList.add('active');
    };

    const handleHideOverlay = () => {
      const overlay = document.getElementsByClassName('ciHeader-overlay')[0];
      overlay.classList.remove('active');
    };

    const onAccountsHover = () => {
      const profilesCookie = Cookies.get('_profiles_user');
      const CSS_SIGNED_IN = 'ciHeader-account-subMenu--isSignedIn';
      const elAccountsMenu = document.getElementsByClassName('ciHeader-account-subMenu')[0];
      const elAccountsBtn = document.getElementsByClassName('ciHeader-accounts-btn')[0];
      // show sub menu
      elAccountsMenu.classList.add('ciHeader-account-subMenu--isActive');
      elAccountsBtn.classList.add('ciHeader-accounts-btn--isActive');
      // activate the correct accounts sub menu
      if ((document.cookie.indexOf('_profiles_user') == -1) || (profilesCookie == "none")) {
        elAccountsMenu.classList.remove(CSS_SIGNED_IN);
      } else {
        elAccountsMenu.classList.add(CSS_SIGNED_IN);
      }
    };

    const onAccountsLeave = () => {
      const elAccountsMenu = document.getElementsByClassName('ciHeader-account-subMenu')[0];
      const elAccountsBtn = document.getElementsByClassName('ciHeader-accounts-btn')[0];
      elAccountsMenu.classList.remove('ciHeader-account-subMenu--isActive');
      elAccountsBtn.classList.remove('ciHeader-accounts-btn--isActive');
    };

    return (
      <div class="ciHeader">
        <div class="ciHeader-overlay" />

        <div class="ciHeader-banner">
          <div class="ciHeader-banner-wrapper">
            <div class="ciHeader-banner-title">
              <span class="ciHeader-banner-title--desktop">{this.desktopBannerMessage}</span>
              <span class="ciHeader-banner-title--mobile">{this.mobileBannerMessage}</span>
            </div>
            <div class="ciHeader-banner-actions">
              <ci-local-store></ci-local-store>
              <customer-contact serviceNumber={this.serviceNumber}></customer-contact>
              <customer-chat></customer-chat>
            </div>
          </div>
        </div>
        <div class="ciHeader-main">
          <div class="ciHeader-main-wrapper">
            <div class="ciHeader-subNav">
              <div class="ciHeader-mobile-menu-btn" id="menuButton" onClick={() => onMenuBtnClick()}>
                <span />
                <span />
                <span />
              </div>
              <ci-mobile-subnav class="ciHeader-mobile-nav" serviceNumber={this.serviceNumber}></ci-mobile-subnav>
              {/* TODO: Upload the logo files to the Prod CDN & swap the src to using the ENV variable */}
              <a href={`${process.env.CI_HOSTNAME}`} class="ciHeader-logo">
                <img alt="customink logo - inky" class="ciHeader-logo-image" src="https://pigment-cdn.staging.customink.com/images/logo-large-horizontal.png.svg" />
              </a>
              <div class="ciHeader-subNav-wrapper" onMouseEnter={() => handleShowOverlay()} onMouseLeave={() => handleHideOverlay()}>
                <div class="ciHeader-subNav-window" />
                <span class="ciHeader-subNav-item " id="productLink" onMouseEnter={() => convertToLinks()}>
                  <a href={`${process.env.CI_HOSTNAME}/products`} class="ciHeader-subNav-link">
                    <span class="ciHeader-subNav-text js-ciHeader-track"
                    data-section="products"
                    data-link="products">Products</span>
                  </a>
                  <ci-products id="productOverlay"></ci-products>
                </span>
                <span class="ciHeader-subNav-item" id="designLink" onMouseEnter={() => convertToLinks()}>
                  <a href={`${process.env.CI_HOSTNAME}/lab`} class="ciHeader-subNav-link">
                    <span class="ciHeader-subNav-text js-ciHeader-track"
                    data-section="design lab"
                    data-link="design lab">Design Lab</span>
                  </a>
                  <ci-design-lab id="designOverlay"></ci-design-lab>
                </span>
                <span class="ciHeader-subNav-item " id="templatesLink" onMouseEnter={() => convertToLinks()}>
                  <a href={`${process.env.CI_HOSTNAME}/inspiration`} class="ciHeader-subNav-link">
                    <span class="ciHeader-subNav-text js-ciHeader-track"
                    data-section="templates"
                    data-link="templates">Templates</span>
                  </a>
                  <ci-template id="templatesOverlay"></ci-template>
                </span>
                <span class="ciHeader-subNav-item" id="solutionsLink" onMouseEnter={() => convertToLinks()}>
                  <span class="ciHeader-subNav-link">
                    <span class="ciHeader-subNav-text js-ciHeader-track"
                    data-section="solutions"
                    data-link="solutions">Solutions</span>
                  </span>
                  <ci-solutions id="solutionsOverlay"></ci-solutions>
                </span>
              </div>
            </div>
            <div class="ciHeader-main-actions">
              <div>
                <div class="ciHeader-accounts--mobile">
                  <icon-button href={`${process.env.CI_HOSTNAME}/profiles/retrieve`} icon={account} alt="account icon" class="js-ciHeader-track"
                  data-section="my account"
                  data-link="my account"></icon-button>
                </div>
                <div class="ciHeader-accounts--desktop" onMouseEnter={() => onAccountsHover()} onMouseLeave={() => onAccountsLeave()}>
                  <ci-button variant="text" href={`${process.env.CI_HOSTNAME}/profiles/retrieve`} styles="ciHeader-accounts-btn" class="js-ciHeader-track"
                  data-section="my account"
                  data-link="my account">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 7.5C17.5 10.5376 15.0376 13 12 13C8.96243 13 6.5 10.5376 6.5 7.5C6.5 4.46243 8.96243 2 12 2C15.0376 2 17.5 4.46243 17.5 7.5ZM8 16.5C6.34315 16.5 5 17.8431 5 19.5V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V19.5C3 16.7386 5.23858 14.5 8 14.5H16C18.7614 14.5 21 16.7386 21 19.5V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19.5C19 17.8431 17.6569 16.5 16 16.5H8ZM12 11C13.933 11 15.5 9.433 15.5 7.5C15.5 5.567 13.933 4 12 4C10.067 4 8.5 5.567 8.5 7.5C8.5 9.433 10.067 11 12 11Z" fill="#4A4A4A"/>
                    </svg>
                    My Account
                  </ci-button>
                  <ci-accounts></ci-accounts>
                </div>
              </div>
              <ci-cart class="js-ciHeader-track"
              data-section="my cart"
              data-link="my cart"></ci-cart>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
